import React, { useState } from 'react'
import { Dialog, Button } from '@material-ui/core'
import DialogView from '../../../../../Dialogos/DialogView'
import { DialogConfirmacionContent } from '../../../../../Dialogos/DialogConfirmacionContent'

function DialogoIngresarSinCupo (props) {
  const { ingresar, titulo, buttonText, mensajeConfirmacion } = props
  const [open, setOpen] = useState(false)

  const handleOpen = () => { setOpen(true) }
  const handleClose = () => { setOpen(false) }

  const ingreso = () => {
    ingresar()
    handleClose()
  }

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth='sm'
      >
        <DialogView
          confirmCallback={ingreso}
          cancelCallback={handleClose}
          title={titulo}
          content={<DialogConfirmacionContent
            message={mensajeConfirmacion}
          />}
        />
      </Dialog>
      <Button
        style={{ margin: 0 }}
        size='small'
        variant='contained'
        color='primary'
        onClick={handleOpen}
      >
        {buttonText}
      </Button>

    </>
  )
}

export default DialogoIngresarSinCupo
